import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Search from "./common/Search";
import i18n from "../i18n";
import LogOutModal from "./common/utils/LogoutModal";
import { logout } from "../Redux/actions";
import { useDispatch, useSelector } from "react-redux";
import Learn from "./HeaderElements/Learn";
import { setLanguageActions } from "../Redux/actions/languageActions";
import { faTimes, faSearch, faXmark, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import headerLogo from "../utils/images/logo.png";
import usa from "../utils/images/usa.png";
import france from "../utils/images/france.png";
import spain from "../utils/images/spain.png";
import mobileLogo from "../utils/images/mob_logo.png";
import MobileSearchBox from "./HeaderElements/MobileSearchBox";
import LearnDropDown from "./HeaderElements/LearnDropDown";




const redirection_url = process.env.REACT_APP_REDIRECTION_URL
const Header = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const mobileMenuRef = useRef(null);
  const categorySlug = useSelector((state) => state.categorySlug.categorySlug);
  const isDynamic = useSelector((state) => state.categorySlug.isDynamic);
  const [learMenulist, setLearMenulist] = useState(false);
  const [searchBox, setSearchBox] = useState(false);
  const openList = () => setLearMenulist(!learMenulist);
  const openSearchBox = () => setSearchBox(!searchBox);
  const dropDownRef = useRef(null);
  const searchDropDownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.userData);
  const authToken = useSelector((state) => state.auth.authToken);
  const [language, setLanguage] = useState(i18n.language);
  const newSlugRef = useRef(categorySlug[language]);
  const [isOpen, setIsOpen] = useState(false);
  const accountTabRef = useRef(null);

  const openMobileMenu = () => {
    setIsMobileMenuOpen(true);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // user language set by locaton
  const detectUserLanguage = async () => {
    try {
      const response = await fetch("https://ipapi.co/json/");
      
      if (!response.ok) {
        throw new Error("Failed to fetch location data");
      }
      const data = await response.json();
      const countryLanguageMap = {
        ES: "es", 
        FR: "fr",
        IN: "en"
      };
      const detectedLanguage = countryLanguageMap[data.country] || "en";
      return detectedLanguage;
    } catch (error) {
      console.error("Error detecting language:", error);
      return "en"; 
    }
  };
  
  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    dispatch(setLanguageActions(selectedLanguage));
    sessionStorage.setItem("language", selectedLanguage);
    setLanguage(selectedLanguage);
    i18n.changeLanguage(selectedLanguage);
    setTimeout(() => {
      const newSlug = newSlugRef.current;
      if(isDynamic){
        navigate(`${newSlug}`);
      }
    }, 0);
  };
 
  const toggleAccountLinks = () => {
    setIsOpen(!isOpen);
  };

  const initializeLanguage = async () => {
    const savedLanguage = sessionStorage.getItem("language");
  if (savedLanguage) {
    setLanguage(savedLanguage);
    i18n.changeLanguage(savedLanguage);
    return;
  }
    const detectedLanguage = await detectUserLanguage();
    if (detectedLanguage !== language) {
      handleLanguageChange({ target: { value: detectedLanguage } });
    }
  };
  useEffect(() => {
    // initializeLanguage();
    // const savedLanguage = sessionStorage.getItem("language");
    // if (savedLanguage) {
    //   setLanguage(savedLanguage);
    //   i18n.changeLanguage(savedLanguage);
    // }

    const handleClickOutside = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const hasAnyValue = Object.values(categorySlug).some((value) => value);
    if (hasAnyValue || categorySlug) {
      newSlugRef.current = categorySlug[language];
    }
  }, [language, categorySlug]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!accountTabRef?.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [accountTabRef]);
  const currentPath = location.pathname;

  useEffect(() => {
    let newPath = currentPath;
    const urlParts = currentPath.split("/").filter(Boolean);

    if (language === "en" || language === "en-GB" || language === "en-US") {
      if (
        urlParts.length > 0 &&
        (urlParts[0] === "es" || urlParts[0] === "fr")
      ) {
        urlParts.shift();
        newPath = `/${urlParts.join("/")}`;
      } else {
        newPath = currentPath.startsWith("/") ? currentPath : `/${currentPath}`;
      }
    } else {
      if (
        urlParts.length > 0 &&
        (urlParts[0] === "en" || urlParts[0] === "es" || urlParts[0] === "fr")
      ) {
        urlParts[0] = language;
        newPath = `/${urlParts.join("/")}`;
      } else {
        newPath = `/${language}${
          currentPath.startsWith("/") ? "" : "/"
        }${currentPath}`;
      }
    }

    if (newPath !== currentPath) {
      navigate(newPath, { replace: true });
    }
  }, [language, currentPath, navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!dropDownRef?.current?.contains(event.target)) {
        setLearMenulist(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropDownRef]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!searchDropDownRef?.current?.contains(event.target)) {
        setSearchBox(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [searchDropDownRef]);

  // Example logoutHandler
  const logoutHandler = () => {
    dispatch(logout());
    navigate("/login");
    setShowModal(false);
  };

  const handleOpen = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };
  const handleRedirect = ()=> {
    if (redirection_url) {
      window.location.assign(redirection_url)
    } else {
      window.location.assign("https://app.tunecutter.com/")
    }
  }
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    document.body.classList.toggle("menu_open", !menuOpen);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

// new header
    const [isSearchOpen, setIsSearchOpen] = useState(false)
    const [learnOpen, setLearnOpen] = useState(false)

    const headerMenu = [
      {name: "Licenses", path: "/licenses"},
      {name: "Uses", path: "/uses"},
      {name: "Learn", path: ""},
      {name: "About", path: "/about-us"},
      {name: "Contact", path: "/contact"},
    ]

    const handleMenuClick = (props)=> {
      if (props=="learn") {
        setLearnOpen(!learnOpen)
      } else {
        setMenuOpen(false)
        document.body.classList.toggle("menu_open", false);
      }
    }

  return (
    <>
    {/* <>
      {location.pathname === `/licenses` || location.pathname === '/es/licencias' || location.pathname === '/fr/licences' ? null : (
        <Link to={`/licenses`} className="header-top transition-colors">
          <div className="container">{t("headerTopLink")}</div>
        </Link>
      )}

      <header className="header-main">
        <div className="container">
          <div className="header-inner d-flex align-items-center justify-content-between">
            <Link
              to={`/`}
              className="header-logo d-flex align-items-center"
            >
              <span className="logo-left">
                <img src="/assets/img/logo-left.svg" alt="logoLeft" width={32} height={32} />
              </span>
              <span className="logo">
                <img src="/assets/img/logo.svg" alt="logo" width={145} height={24}/>
              </span>
            </Link>
            <div className="header-right d-flex align-items-center">
              <div className="lang-selector">
                <select
                  name=""
                  className="lang-options"
                  value={language}
                  onChange={handleLanguageChange}
                  // disabled
                >
                  <option value="en">🇺🇸</option>
                  <option value="es">🇪🇸</option>
                  <option value="fr">🇫🇷</option>
                </select>
              </div>

              <div
                className="header-search"
                onClick={openSearchBox}
                ref={searchDropDownRef}
              >
                <Link>
                  <img src="/assets/img/search-ico.svg" alt="search-ico" width={24} height={24} />
                </Link>
              </div>
              <button className="redirection-btn glow" onClick={handleRedirect}>App Legis</button>

              <div className="ham-menu">
                <Link className="ham-btn" onClick={openMobileMenu}>
                  <img src="/assets/img/ham.svg" alt="ham"/>
                </Link>
                <div
                  className={`mobile-menu-main ${
                    isMobileMenuOpen ? "show" : ""
                  }`}
                >
                  <div className="mobile-menu-inner" ref={mobileMenuRef}>
                    <Link className="close-ico" onClick={closeMobileMenu}>
                      <img src="/assets/img/close-ico.svg" alt="" />
                    </Link>
                    <Link
                      to={`/`}
                      className="header-logo d-flex align-items-center"
                    >
                      <span className="logo-left">
                        <img src="/assets/img/logo-left.svg" alt="" />
                      </span>
                      <span className="logo">
                        <img src="/assets/img/logo.svg" alt="" />
                      </span>
                    </Link>
                    <ul>
                      <li>
                        <Link to={`/music`}>
                          {t("headerMusicLink")}
                        </Link>
                      </li>
                      <li>
                        <Link to={`/licenses`}>
                          {t("licenses")}
                        </Link>
                      </li>
                      <li>
                        <Link to={`/uses`}>{t("uses")}</Link>
                      </li>
                      <li
                        className={`has-children ${isDropdownOpen && "active"}`}
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        <Link className="subItem">{t("learn")}</Link>
                        <ul>
                          <Learn isMobileMenuOpen={isMobileMenuOpen} />
                        </ul>
                      </li>
                      <li>
                        <Link to={`/about-us`}>
                          {t("about")}
                        </Link>
                      </li>
                      <li>
                        <Link to={`/contact`}>
                          {t("contact")}
                        </Link>
                      </li>
                    </ul>
                    <div className="menu-btn d-flex align-items-center">
                      <div className="lang-selector">
                        <select
                          name=""
                          className="lang-options"
                          value={language}
                          onChange={handleLanguageChange}
                          // disabled
                        >
                          <option value="en">🇺🇸</option>
                          <option value="es">🇪🇸</option>
                          <option value="fr">🇫🇷</option>
                        </select>
                      </div>
                      <div
                        className="header-search"
                        onClick={openSearchBox}
                        ref={searchDropDownRef}
                      >
                        <Link>
                          <img src="assets/img/search-ico.svg" alt="" />
                        </Link>
                      </div>
                      <div className="redirection-btn glow" onClick={handleRedirect}>App Legis</div>
                    </div>
                  </div>
                </div>
              </div>

              {authToken ? (
                <div
                  className="account-tab"
                  onClick={toggleAccountLinks}
                  ref={accountTabRef}
                >
                  <Link className="acc-img">
                    <img
                      src={
                        userData?.full_image_url
                          ? userData?.full_image_url
                          : "/assets/img/user.jpg"
                      }
                      alt="profile-image"
                      width={50} 
                      height={50}
                    />
                    <i className="fa-solid fa-angle-down"></i>
                  </Link>
                  <div className={`account-links ${isOpen ? "" : "d-none"}`}>
                    <ul>
                      <li>
                        <Link to="/my-dashboard">
                          <i className="fa-solid fa-gauge"></i>{" "}
                          {t("header_Dashboard")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/my-profile">
                          <i className="fa-solid fa-user-tie"></i>{" "}
                          {t("header_My_Profile")}
                        </Link>
                      </li>
                      <li onClick={handleOpen}>
                        <Link>
                          <i className="fa-solid fa-gear"></i>{" "}
                          {t("header_Logout")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              ) : (
                <div className="log-tab">
                  <Link to={`/login`}> {t("header_Login")}</Link> /
                  <Link to={`/signup`}>
                    {" "}
                    {t("header_Register")}
                  </Link>
                </div>
              )}
            </div>

            <div className="header-menu">
              <ul>
                <li>
                  <Link to={`/music`}>
                    {t("headerMusicLink")}
                  </Link>
                </li>
                <li>
                  <Link to={`/licenses`}>{t("licenses")}</Link>
                </li>
                <li>
                  <Link to={`/uses`}>{t("uses")}</Link>
                </li>

               
                <li
                  className={`${
                    learMenulist ? "has-children active" : "has-children"
                  }`}
                  onClick={openList}
                  ref={dropDownRef}
                >
                  <Link>{t("learn")}</Link>
                  <ul className={learMenulist ? "active" : ""}>
                    <li>
                      <div className="pop-panel">
                        <div className="panel-top">
                          <ul>
                            <Learn isMobileMenuOpen={isMobileMenuOpen} />
                          </ul>
                        </div>
                        <div className="panel-bottom">
                          <Link to="/blog">
                            <h4>View all</h4>
                            <p>
                              Want to learn more? Check out all our articles!
                            </p>
                          </Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to={`  /about-us`}>{t("about")}</Link>
                </li>
                <li>
                  <Link to={`/contact`}>{t("contact")}</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
      <Search
        searchBox={searchBox}
        setSearchBox={setSearchBox}
        searchDropDownRef={searchDropDownRef}
      />
      {showModal && (
        <LogOutModal
          show={showModal}
          handleClose={handleClose}
          logoutHandler={logoutHandler}
        />
      )}
    </> */}
     <header className='header'>
        <div className="container_fluid">
          <div className='header_inner'>
            <div className="header_inner_left">
            <div className='mob_trigger mob_show' onClick={toggleMenu}>
                <span></span><span></span><span></span>
            </div>
            <Link to=""><img src={isMobile ? mobileLogo : headerLogo} alt="Logo" /></Link>
            </div>
            <div className='header_right'>
              <button className="mobsearch_trigger" onClick={()=>setIsSearchOpen(true)}><FontAwesomeIcon icon={faSearch}/></button>
              <button className='solid_btn' onClick={()=> window.location.assign(`${process.env.REACT_APP_REDIRECTION_HOME_URL}/auth/register`)}>{t("freeSignUpbtn")}</button>
              <button className='border_btn_getPro' onClick={()=> navigate('/pricing')}>{t("footer_pricing")}</button>
              <button className='border_btn' onClick={()=> window.location.assign(`${process.env.REACT_APP_REDIRECTION_HOME_URL}/music`)}>{t("browseMusicBtn")}</button>
              <div className="lang-selector">
                <select
                  name=""
                  className="lang-options"
                  value={language}
                  onChange={handleLanguageChange}
                  // disabled
                >
                  <option value="en">🇺🇸</option>
                  <option value="es">🇪🇸</option>
                  <option value="fr">🇫🇷</option>
                </select>
            </div>
              <div className='mob_trigger mob_hide' onClick={toggleMenu}>
                <span></span><span></span><span></span><span></span>
              </div>
            </div>
          </div>
        </div>
        {/* Side Menu */}
        <div className={`side_menu ${menuOpen ? "open" : ""}`}>
          <div className="side_menu_close" onClick={toggleMenu}><FontAwesomeIcon icon={faTimes} /></div>
          <ul>
          <li className="side_menu_li_btn"><Link onClick={()=> window.location.assign(`${process.env.REACT_APP_REDIRECTION_HOME_URL}/auth/login`)}>{t("signInText")}</Link></li>
            {/* <li><Link to="/blog" onClick={()=>handleMenuClick()}>{t("blogBtn")}</Link></li> */}
            <li><Link to="/pricing" onClick={()=>handleMenuClick()}>{t("footer_pricing")}</Link></li>
            {/* <li><Link to="/Uses" onClick={()=>handleMenuClick()}>{t("uses")}</Link></li> */}
            <li><span onClick={()=>handleMenuClick("learn")}>{t("learn")} <FontAwesomeIcon icon={faChevronDown} /></span><LearnDropDown handleMenuClick={handleMenuClick} learnOpen={learnOpen} setMenuOpen={setMenuOpen} /></li>
            <li><Link to="/about-us" onClick={()=>handleMenuClick()}>{t("about")}</Link></li>
            {/* <li><Link to="#" onClick={()=>setIsLearnOpen(true)}>Learn</Link></li> */}
            <li><Link to="/contact" onClick={()=>handleMenuClick()}>{t("contact")}</Link></li>
            {/* <li><Link to="/">Brand Advocate</Link></li> */}
          </ul>
        </div>

        {/* Overlay */}
        {menuOpen && <div className="overlay" onClick={toggleMenu}></div>}
      </header>
    {isSearchOpen && <MobileSearchBox isSearchOpen={isSearchOpen} setIsSearchOpen={setIsSearchOpen} /> }
    </>
  );
};

export default Header;
